import { render, staticRenderFns } from "./CbsObjectReport.vue?vue&type=template&id=9006142a&scoped=true"
import script from "./CbsObjectReport.vue?vue&type=script&lang=js"
export * from "./CbsObjectReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9006142a",
  null
  
)

export default component.exports